import { mapState, mapGetters, mapActions } from 'vuex'

export const notificationHeaderComputed = {
  ...mapState('notificationHeader', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('notificationHeader', [
    'getShowList',
    'getNotificationDetails',
  ]),
}

export const notificationHeaderMethods = mapActions('notificationHeader', [
  'fetchingShowList',
  'fetchingNotificationDetails',
])
